module.exports = __webpack_public_path__ + "static/media/disable-user.62f444f9.svg";